import React from "react";
import { GAME_CONFIG } from "../config";

export default function GameHint({
  showPopupText,
  isEligibleToNext,
  currentStage,
}) {
  let canRender = GAME_CONFIG.hasPrepStage ? currentStage > 0 : true;
  let textIndexStart = GAME_CONFIG.hasPrepStage ? 1 : 0;

  return (
    canRender && (
      <div className="popup-bottom">
        <p style={{ opacity: 0 }}>asdasd</p>
        <p className={`text-center popup-text ${showPopupText && "active"}`}>
          Beberapa saat kemudian
        </p>
        <p className={`text-right desc-text ${isEligibleToNext && "active"}`}>
          {currentStage == textIndexStart
            ? "Untuk atasi mata merah karena iritasi ringan"
            : currentStage == textIndexStart + 1
            ? "Untuk atasi gejala mata kering"
            : currentStage == textIndexStart + 2 &&
              "Untuk atasi mata merah karena iritasi ringan dengan sensasi dingin"}
        </p>
      </div>
    )
  );
}
